import React from "react";
import { DndProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import ShowPage from './show-page';

export default (props) => (
  <DndProvider backend={HTML5Backend}>
    <ShowPage {...props} />
  </DndProvider>
);
